import { Organization } from 'store/global/types';

export const ORGANIZATION = 'organization';

export const buildOptions = (data: Organization[] = [], inputText: string) => {
  if (inputText.length < 3) return [];
  return data.map((organization: Organization) => ({
    ...organization,
    id: organization.policyNumber,
    label: organization.subscriber + ' - ' + organization.policyNumber,
  }));
};
